/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchResult } from './SearchResult';
import {
    SearchResultFromJSON,
    SearchResultFromJSONTyped,
    SearchResultToJSON,
} from './SearchResult';

/**
 * 
 * @export
 * @interface SearchResultPage
 */
export interface SearchResultPage {
    /**
     * 
     * @type {Array<SearchResult>}
     * @memberof SearchResultPage
     */
    results: Array<SearchResult>;
    /**
     * 
     * @type {number}
     * @memberof SearchResultPage
     */
    totalResults: number;
}

/**
 * Check if a given object implements the SearchResultPage interface.
 */
export function instanceOfSearchResultPage(value: object): value is SearchResultPage {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    return true;
}

export function SearchResultPageFromJSON(json: any): SearchResultPage {
    return SearchResultPageFromJSONTyped(json, false);
}

export function SearchResultPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultPage {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(SearchResultFromJSON)),
        'totalResults': json['totalResults'],
    };
}

export function SearchResultPageToJSON(value?: SearchResultPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(SearchResultToJSON)),
        'totalResults': value['totalResults'],
    };
}

